const trustedSourcesRegexp =
  /^(https:\/\/support\.wix\.com|https:\/\/(.+)\.support\.com|https?:\/\/localhost(:\d+)?)$/i;

export const isTrustedCopilotHost = (origin: string): boolean => trustedSourcesRegexp.test(origin);
